import React from "react";
import {AlertTooltip} from "./AlertTooltip";
import {PROPERTIES_FOR_METRIC} from "../../../metrics";

export class ValueVsExpectedAlertTooltip extends AlertTooltip {
    render() {
        let tooltipContent = this.tooltipContent();
        return (
            <div className="alert-tooltip">
                <div className="alert-tooltip-marker">
                    <i className="fa fa-circle" aria-hidden="true"/>
                </div>
                <div className="alert-tooltip-body">
                    <div className="alert-tooltip-header">
                        <div className="col-6 m-0 p-0"><p
                            className="alert-tooltip-title">{PROPERTIES_FOR_METRIC[this.props.metricName]["Spanish"]}<span></span>
                        </p></div>
                    </div>
                    {tooltipContent}
                </div>
            </div>

        )
    }

    tooltipContent() {
        const vsPeriodValueText = this.props.vsPeriodValue === this.props.vsPeriodProportionalValue ? <span className="font-weight-bold">{this.props.vsPeriodValue}</span> : [<span className="font-weight-bold">{this.props.vsPeriodValue}</span>, ` (se considero el valor proporcional de ${this.props.vsPeriodProportionalValue})`];
        return (
            <div className="alert-tooltip-content">
                <p className="alert-tooltip-description">
                    {this.props.mainPeriod}: <span className="font-weight-bold">{this.props.mainPeriodValue}</span>
                    <br/>
                    {this.props.vsPeriod}: {vsPeriodValueText}
                </p>
            </div>
        );
    }
}
